import { useState, useRef } from "react";

type Props = {
  resetError: () => void;
};

function Calendarcheck({ resetError }: Props) {
  const calendarRef = useRef<HTMLInputElement | null>(null);
  const [urlVerificada, setUrlVerificada] = useState(false);
  const [calendarStatus, setCalendarStatus] = useState("");

  const verificarUrl = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    const calendarValue = calendarRef.current
      ? calendarRef.current.value
      : null;

    if (calendarValue === "") {
      setCalendarStatus("");
      setUrlVerificada(false);
      resetError();
    } else if (calendarValue && calendarValue.startsWith("https://cal.com/")) {
      setCalendarStatus("La URL ingresada es válida.");
      setUrlVerificada(true);
      resetError();
    } else {
      setCalendarStatus(
        "La URL ingresada no es válida. Por favor, pega la URL del snippet de cal.com"
      );
      setUrlVerificada(false);
    }
  };

  return (
    <div>
      <div className="url-calcom">
        <label htmlFor="url">Pega aquí la URL del calendario de cal.com:</label>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: 20,
            flexWrap: "wrap",
            rowGap: 15,
            columnGap: 10,
          }}
        >
          <input
            ref={calendarRef}
            style={{
              flex: "1 0 100px",
              maxWidth: "450px",
            }}
            type="text"
            id="calendar_url"
            name="calendar_url"
            placeholder="https://cal.com/your-calendar"
          />
          <button
            style={{
              flex: "1 0 150px",
              maxWidth: 150,
              justifySelf: "flex-end",
            }}
            className="theme-btn btn-style-one"
            onClick={verificarUrl}
          >
            Verificar URL
          </button>
        </div>
      </div>

      {/* Status Message */}
      <p>{calendarStatus}</p>

      <p>
        ¿No tienes un calendario?{" "}
        <a
          href="https://cal.com"
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary"
        >
          Crea uno aquí en cal.com
        </a>
      </p>

      {/* Conditionally Render Calendar Iframe */}
      {urlVerificada &&
        calendarRef.current?.value.startsWith("https://cal.com/") && (
          <div className="mt-4">
            <p className="h5">Preview de calendario</p>
            <iframe
              src={calendarRef.current.value}
              className="w-100"
              style={{ height: "600px" }}
              title="Calendario"
            ></iframe>
          </div>
        )}
    </div>
  );
}

export default Calendarcheck;
